export default __webpack_public_path__ + "static/media/default-background-phone.fb746b83.mp4";